import { Outlet } from 'react-router-dom';
import Navbar from '../Components/Navbar01';
import Sidebar from '../Components/Sidebar';
import SecondaryNavbar from '../Components/Navbar02';
import { useState } from 'react';
import './UserLayout.css'; // 👈 new css file
import FooterSection from '../Components/Footer.jsx';
import ConsultSection from '../PageElements/HomePageElements/ConsultSection.jsx';


function UserLayout() {
  
  const [collapsed, setCollapsed] = useState(false);

  const members = [
    { name: "John Doe", relation: "Self" },
    { name: "Jane Doe", relation: "Wife" },
    { name: "Michael Doe", relation: "Son" },
    { name: "Sophia Doe", relation: "Daughter" },
    { name: "David Doe", relation: "Father" },
    { name: "Emma Doe", relation: "Mother" },
    { name: "Chris Doe", relation: "Brother" },
    { name: "Olivia Doe", relation: "Sister" },
    { name: "Liam Doe", relation: "Grandfather" },
    { name: "Ava Doe", relation: "Grandmother" }
  ];

  const userData = {
    firstName: "Babun",
    lastName: "Roy",
    dob: "00-00-2000",
    gender: "Male",
    email: "babunroy987@gmail.com",
    mobile: "1234567890",
    city: "Bongaon",
    state: "West Bengal",
    zipcode: "700001",
    landmark: "Near Railway Station",
    address: "Bongaon, West Bengal"
  };
  // Demo Test Data
  const bloodSugarData = [
    { date: "01-Sep", sugar: 110 },
    { date: "10-Sep", sugar: 125 },
    { date: "20-Sep", sugar: 98 },
    { date: "28-Sep", sugar: 130 },
  ];

  const cholesterolData = [
    { test: "Test 1", cholesterol: 180 },
    { test: "Test 2", cholesterol: 190 },
    { test: "Test 3", cholesterol: 175 },
  ];

  const hemoglobinData = [
    // { month: "July", hb: 13.5 },
    // { month: "Aug", hb: 12.8 },
    // { month: "Sept", hb: 14.2 },
  ];

  return (
    <>
      <Navbar />
      <SecondaryNavbar inDashboard={true} />
      <div className="layout-container">
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />

        <div
          className={`layout-content ${collapsed ? "collapsed" : "expanded"}`}
        >
          <Outlet context={{ userData, members, bloodSugarData, cholesterolData, hemoglobinData }} />
        </div>
      </div>
     
    </>
  );
}

export default UserLayout;
